import iconLift from './img/optionsImages/icon-lift.png';
import iconHeart from './img/optionsImages/icon-heart.png';
import iconScales from './img/optionsImages/icon-scales.png';
import iconMuscle from './img/optionsImages/icon-muscle.png';
import trueImg from './img/optionsImages/true_grey.svg';
import falseImg from './img/optionsImages/false_grey.svg';
import goalTone from './img/optionsImages/goal_tone.png';
import goalBuild from './img/optionsImages/goal_build.png';
import goalLose from './img/optionsImages/goal_lose.png';
import goalChange from './img/optionsImages/goal_change.png';
import chest from './img/optionsImages/zones_chest.png';
import arms from './img/optionsImages/zones_arms.png';
import belly from './img/optionsImages/zones_belly.png';
import back from './img/optionsImages/zones_back.png';
import glutes from './img/optionsImages/zones_glutes.png';
import legs from './img/optionsImages/zones_legs.png';
import zonesAthome from './img/optionsImages/active_athome.svg';
import zonesWalking from './img/optionsImages/active_walking.svg';
import zonesGym from './img/optionsImages/active_gym.svg';
import zonesRunning from './img/optionsImages/active_running.svg';
import zonesMeditations from './img/optionsImages/active_meditations.svg';
import zonesYoga from './img/optionsImages/active_yoga.svg';
import zonesDance from './img/optionsImages/active_dance.svg';
import activitiesDumbbells from './img/optionsImages/equip_dumbbells.svg';
import activitiesBarbell from './img/optionsImages/equip_barbel.svg';
import activitiesTreadmill from './img/optionsImages/equip_treadmill.svg';
import activitiesBands from './img/optionsImages/equip_bands.svg';
import activitiesNone from './img/optionsImages/equip_none.svg';
import iconMeat from './img/optionsImages/food_all.svg';
import iconVeget from './img/optionsImages/food_vegetarian.svg';
import iconVegan from './img/optionsImages/food_vegan.svg';
import iconKeto from './img/optionsImages/food_keto.svg';

const optionsImages = {
	goal: {
		lose_weight: goalLose,
		gain_muscles: goalBuild,
		body_tone_up: goalTone,
		gain_healthier_life: goalChange
	},
	activities_preferences: {
		workout_man: zonesAthome,
		walking: zonesWalking,
		gym_man: zonesGym,
		running: zonesRunning,
		meditations_man: zonesMeditations,
		yoga_man: zonesYoga,
		dance_man: zonesDance
	},
	age: {
		'18-29': iconScales,
		'30-39': iconLift,
		'40-49': iconHeart,
		'50-59+': iconMuscle
	},
	diet_type: {
		all: iconMeat,
		vegetarian: iconVeget,
		vegan: iconVegan,
		keto: iconKeto
	},
	devices: {
		dumbells: activitiesDumbbells,
		barbell: activitiesBarbell,
		treadmill: activitiesTreadmill,
		bands: activitiesBands,
		none: activitiesNone
	},
	zones: {
		chest,
		arms,
		belly,
		back,
		glutes,
		legs
	},
	successfully_lost_weight: {
		yes: trueImg,
		no: falseImg
	}
};

export default optionsImages;
